import React from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'xs' | 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

const variants: Record<Variant, React.CSSProperties> = {
  primary: {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: '#fff',
    border: 'none',
    boxShadow: '0 1px 12px rgba(16,185,129,0.25)',
  },
  secondary: {
    background: 'var(--bg-card-el)',
    color: 'var(--tx-3)',
    border: '1px solid var(--bd)',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--tx-4)',
    border: '1px solid transparent',
  },
  danger: {
    background: 'rgba(239,68,68,0.1)',
    color: '#f87171',
    border: '1px solid rgba(239,68,68,0.2)',
  },
};

const sizes: Record<Size, React.CSSProperties> = {
  xs: { padding: '4px 10px', fontSize: 11, gap: 5, borderRadius: 7 },
  sm: { padding: '6px 12px', fontSize: 12, gap: 6, borderRadius: 8 },
  md: { padding: '8px 16px', fontSize: 13, gap: 7, borderRadius: 10 },
  lg: { padding: '10px 20px', fontSize: 14, gap: 8, borderRadius: 11 },
};

export function Button({ variant = 'secondary', size = 'md', icon, children, style, ...props }: ButtonProps) {
  return (
    <button
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'opacity 0.15s, transform 0.1s',
        whiteSpace: 'nowrap',
        ...variants[variant],
        ...sizes[size],
        ...style,
      }}
      onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.opacity = '0.82'; }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.opacity = '1'; }}
      onMouseDown={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(0.97)'; }}
      onMouseUp={(e) => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'; }}
      {...props}
    >
      {icon && <span style={{ display: 'flex', flexShrink: 0 }}>{icon}</span>}
      {children}
    </button>
  );
}
